import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../http/authentication.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // const currentUser = this.authenticationService.currentUserValue;
        const currentUser = this.authenticationService.userInfo;
        if (currentUser != null) {
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        // this.router.navigate([{ outlets: { primary: 'login', popup: null }} ], { queryParams: { returnUrl: state.url }});
        this.router.navigate([{ outlets: { primary: environment.loginPagePath, popup: null }} ], { queryParams: { returnUrl: state.url }});
        return false;
    }

}
